import { designSystemTranslations } from '@aionzdev/design-system';
import { modulesTranslations } from '@aionzdev/modules';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { catchError, map, Observable, of } from 'rxjs';

const libraryTranslations: Record<string, TranslationObject> = {
  'pt-BR': { ...designSystemTranslations['pt-BR'], ...modulesTranslations['pt-BR'] },
};

@Injectable()
export class AionzTranslateLoader implements TranslateLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string): Observable<TranslationObject> {
    return this.http.get<TranslationObject>(`assets/i18n/${lang}.json`).pipe(
      map(appTranslations => ({
        ...(libraryTranslations[lang] ?? {}),
        ...appTranslations,
      })),
      catchError(() => of(libraryTranslations[lang] ?? {})),
    );
  }
}
